import { billOfMaterialsIdFormat } from "@redotech/redo-model/ids";
import * as z from "zod/v4";
import { null as zNull } from "zod/v4";

export const BomListItemSchema = z.object({
  id: billOfMaterialsIdFormat.schema,
  name: z.string(),
  tags: z.array(z.string()).optional(),
});

export type BomListItem = z.infer<typeof BomListItemSchema>;

export const getBoms = {
  name: "getBoms" as const,
  input: zNull(),
  output: z.object({ boms: z.array(BomListItemSchema) }),
};
